import { useState } from 'react'
import NavBar from '@/components/NavBar'
import Header from '@/components/common/Head'
import Loader from '@/components/common/Loader'

const Layout = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <>
      <Header />
      <div className="content">
        <NavBar setIsLoading={setIsLoading} />
        {isLoading ? <Loader /> : children}
      </div>
    </>
  )
}

export default Layout
